import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {AlertService, AuthenticationService, ConstantService, UserService} from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { Quote, QuoteService } from '..';
import { ReservationService } from '@app/_components/reservation';
import { Calendar } from 'primeng/calendar';
import { GuestMasterProfileListComponent } from '@app/_components/guest-master-profile/guest-master-profile-list/guest-master-profile-list.component';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {OrderService} from "@app/_components/order";
import {CurrencyPipe, Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {LostFoundService} from "@app/_components/lost-found/lost-found.service";
import {PropertyService} from "@app/_components/property";

@Component({
    selector: 'app-edit-quote',
    templateUrl: './edit-quote.component.html',
    styleUrls: ['./edit-quote.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class EditQuoteComponent implements OnInit, OnDestroy {

  @ViewChild('checkInDateCal') public checkInDateCalender: Calendar;
  @ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;
  @ViewChild('expireDateCal') public expireDateCalender: Calendar;

  constructor(
    private quoteService: QuoteService,
    private authenticationService: AuthenticationService,
    private primengConfig: PrimeNGConfig,
    private orderService: OrderService,
    private userService: UserService,
    private alertService: AlertService,
    private reservationService: ReservationService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private location1: Location,
    private activatedRoute: ActivatedRoute,
    private lostFoundService: LostFoundService,
    private propertyService: PropertyService,
    private constantService: ConstantService,
    private dialog: MatDialog,
    private router: Router,
    private renderer: Renderer2,
    private currencyPipe: CurrencyPipe,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title,
      this.quote = data.quote,
      this.selectedProperties = data.quote?.selectedProperties;
    console.log(this.selectedProperties)
    this.childrens = this.reservationService.children;
    this.numAdults = this.reservationService.numAdults;
    this.quoteDiscPcts = this.quoteService.quoteDiscPct;
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  @Input() quote: Quote;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();
  selectedIndex: number = 0;
  // data
  quoteId: number;
  searchName: any = null;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  childrens: any[];
  numAdults: any[];
  quoteDiscPcts: any[];
  maxDate: Date;
  minDate: Date;
  selectedProperties: any = [];
  updatedCheckInDate: Date;
  checkOutDateBasedOnCheckinDate: Date;
  isDisplayClearDates = false;
  isDateLessThanCheckinDate = false;
  currentUser: User;
  currentUserSubscription: Subscription;
  reservedProperties: any[];

  validationMessages = {
    shortTermRentalId: [{ type: 'required', message: 'Required' }],
    emailAddress: [{ type: 'required', message: 'Required' },
      { type: 'email', message: 'Not a valid Email' }],
    mobilePhone: [],
    numAdults: [{ type: 'required', message: 'Required' }],
    numChildren: [{ type: 'required', message: 'Required' }],
    checkOutDateTime: [{ type: 'required', message: 'Required' }],
    guestNotes: [],
    sendEmail: [{ type: 'required', message: 'Please select Email or Text' }],
    sendText: [{ type: 'required', message: 'Required' }],
    quoteExpirationDateTime: [{ type: 'required', message: 'Required' }],
    checkInDateTime: [{ type: 'required', message: 'Required' }],
    firstName: [{ type: 'required', message: 'Required' }],
    lastName: [{ type: 'required', message: 'Required' }],
    quotePrice: [],
    quoteDiscPct: [],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let day = today.getDate();
    this.updatedCheckInDate = today;
    this.minDate = new Date();
    this.maxDate = new Date(year + 3, month, day);
    this.primengConfig.ripple = true;
    // this.paymentList = [];
    this.formBuild();
    // this.formBuildForAddNewReservation();
    // this.formBuildForInvoiceOrderDetail();
    //  this.formBuildForInvoiceOrderDetailUpdateAndDelete();
    //  this.fetchProperties();

    // if we were passed the whole quote object
    /*if (this.quote) {
      this.quoteId = this.quote.quoteId;
      this.form1.patchValue(this.quote);
      this.form1.patchValue({
        checkInDateTime: this.quote.checkInDate,
        checkOutDateTime: this.quote.checkOutDate
      });
    }
    this.form1.patchValue({
      reservationistUserId: this.currentUser.userId,
    });*/
    this.addQuoteDetails();
  }

  async addQuoteDetails() {
    this.reservedProperties = [];
    await Promise.all(this.selectedProperties.map(async property => {
      let yieldPrice;
      let isAvailable = true;
      if(this.form1.value.checkInDateTime)
      {
        let checkInDateTime = this.form1.value.checkInDateTime;
        let checkOutDateTime = this.form1.value.checkOutDateTime;
        if(property?.rates)
        {
          property.rates.forEach(rate => {
            let analyzedDateObj = new Date(rate.analyzedDate);
            analyzedDateObj.setHours(0, 0, 0, 0);
            checkInDateTime.setHours(0, 0, 0, 0);
            checkOutDateTime.setHours(0, 0, 0, 0);
            if(analyzedDateObj.getTime() === checkInDateTime.getTime())
            {
              yieldPrice = rate.yieldPriceAMT ? rate.yieldPriceAMT : rate.rateYieldPriceAMT;
            }
            if(analyzedDateObj.getTime() >= checkInDateTime.getTime() && analyzedDateObj.getTime() < checkOutDateTime.getTime())
            {
              if(rate.reservationId && rate.reservationId > 0)
              {
                isAvailable = false;
              }
            }
          });
        }
      }

      try {
        let pictureName = await this.findPropertyById(property?.rates[0]?.shortTermRentalId);
        if (pictureName != null) {
          property.thumbImg = "https://thumb.kbmhawaii.com/" + pictureName;
        }
      } catch (err) {
        console.error('Error getting picture name:', err);
      }

      if(isAvailable)
      {
        this.quoteDetailAPIList.push(
          this.formBuilder.group({
            yieldPrice: [yieldPrice],
            isAvailable: [isAvailable],
            quotePrice: [this.currencyPipe.transform(yieldPrice, 'USD', 'symbol', '1.2-2') || ''],
            quoteDiscPct: [],
            shortTermRentalId: [property?.rates[0]?.shortTermRentalId],
            guestNotes: [],
            opsNotes: [],
            addressDevelopmentName: [property.addressDevelopmentName],
            propertyCode: [property.propertyCode],
            thumbImg: [property.thumbImg]
          })
        );
      }
      else
      {
        this.reservedProperties.push(property.propertyCode);
        console.log(this.reservedProperties)
      }
    }));
  }

  findPropertyById(shortTermRentalId: any): Promise<any> {
    return new Promise((resolve) => {
      this.quoteService.findPictureByPropertyId(shortTermRentalId)
        .subscribe(
          (res: any) => {
            resolve(res?.data?.picture?.fileName ?? null);
          },
          (err: any) => {
            console.error('Could not load picture for shortTermRentalId=' + shortTermRentalId, err);
            resolve(null);
          },
          () => {
            this.formLoading = false;
          }
        );
    });
  }

  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.form1.value.quoteId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete()
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.quoteService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.quote = res.data.quote;
            this.doAdd.emit(this.quote);
          },
          (err: any) => {
            console.log('quote-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('quote: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;

      this.quoteService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.quote = res.data.quote;
            this.doUpdate.emit(this.quote);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.quoteService.delete(this.form1.value.quoteId)
        .subscribe(
          (res: any) => {
            console.log('quote-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.quote);
          },
          (err: any) => {
            console.log('quote-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      quoteId: [this.quote.quoteId],
      shortTermRentalId: [],
      numAdults: [this.quote.numAdults, Validators.required],
      numChildren: [this.quote.numChildren],
      checkOutDateTime: [moment(this.quote.checkOutDateTime).toDate(), Validators.required],
      quoteExpirationDateTime: [moment(this.quote.quoteExpirationDateTime).toDate(), Validators.required],
      checkInDateTime: [moment(this.quote.checkInDateTime).toDate(), Validators.required],
      guestNotes: [],
      opsNotes: [],
      sendEmail: [this.quote.sendEmail],
      sendText: [],
      guestMasterProfileId: [this.quote.guestMasterProfileId],
      reservationistUserId: [this.quote.reservationistUserId],
      guestProfile: this.formBuilder.group({
        guestMasterProfileId: [''],
        firstName: [],
        lastName: [],
        emailAddress: ['', Validators.required],
        guestCompanions: new UntypedFormArray([]),
        mobilePhone: [''],
      }),
      quoteDetailAPIList: this.formBuilder.array([]),
    });
  }

  get quoteDetailAPIList(): FormArray {
    return this.form1.get('quoteDetailAPIList') as FormArray;
  }

  // change checkout date
  checkOutChange(e: any) {
    this.isDisplayClearDates = true;
    // this.guestDropdownCount.show();
  }

  // if select checkout date at that time check checkin date must be below lessthan one day of selected date
  onKeyDateForCheckOutDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    if (this.form1.value.checkInDateTime) {
      let today = new Date(this.form1.value.checkInDateTime);
      this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
      this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    }
  }

  // compare checkin and checkout dates
  compareDate(date: any) {
    this.isDateLessThanCheckinDate = false;
    if (Date.parse(date.target.value) < Date.parse(moment(this.checkOutDateBasedOnCheckinDate).format("MM/DD/YYYY"))) {
      this.isDateLessThanCheckinDate = true;
    }
  }

  // open guest modal
  openGuestModal(e: any) {
    // this.dropdown.show();
  }

  // change checking date
  checkInChange(e: any) {
    let today = new Date(e.valueOf());
    this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
    this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    this.isDisplayClearDates = true;
    this.form1.patchValue({ checkOutDateTime: null });
    window.setTimeout(() => {
      this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
    }, 1);
  }

  removeProperty(index)
  {
    const propertyCode = this.quoteDetailAPIList.at(index)?.get('propertyCode')?.value || 'this property';
    this.confirmationService.confirm({
      message: `Remove ${propertyCode} from this quote?`,
      header: 'Confirm Remove',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedProperties.splice(index, 1);
        this.quoteDetailAPIList.removeAt(index);
        this.doUpdate.emit(this.selectedProperties);
      },
      reject: () => {}
    });
  }

  updateQuotePrice(i: number) {
    const quoteDetail = this.quoteDetailAPIList.at(i);
    const yieldPrice = quoteDetail.get('yieldPrice')?.value;
    const quoteDiscPct = quoteDetail.get('quoteDiscPct')?.value;

    if (yieldPrice != null && quoteDiscPct != null) {
      // Calculate the quote price after discount
      let newQuotePrice = yieldPrice * (1 - Math.abs(quoteDiscPct));
      newQuotePrice = Math.round(newQuotePrice * 100) / 100;
      quoteDetail.get('quotePrice')?.setValue(newQuotePrice);
    }
  }

  // if select checkin date at that time checkout date set as null
  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    // this.form1.patchValue({
    // 	checkOutDate: ""
    // });
  }

  sendQuote()
  {
    console.log(this.form1.value);
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      // Check if either sendEmail or sendText is selected
      const sendEmail = this.form1.get('sendEmail')?.value;
      const sendText = this.form1.get('sendText')?.value;
      if (!sendEmail && !sendText) {
        this.form1.get('sendEmail')?.setErrors({ required: true });
      } else {
        // If either checkbox is selected, remove the validation error
        this.form1.get('sendEmail')?.setErrors(null);
        this.form1.get('sendText')?.setErrors(null);
      }
      if (this.form1.invalid) {
        return;
      }
      if (this.quoteDetailAPIList.length === 0) {
        this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please select at least one property before sending the quote.', life: 5000 });
        return;
      }
      console.log('quote-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.quoteService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('quote-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            // this.quote = res.data.quote;
            // this.doAdd.emit(this.quote);
          },
          (err: any) => {
            console.log('quote-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  findGuest()
  {

    const dialogConfig = new MatDialogConfig();
    const data = {
    };
    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "120vw";
    dialogConfig.width = "60vw";
    dialogConfig.data = {
      title : "Quote",
      showCloseButton: true,
      quote: data
    };
    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(GuestMasterProfileListComponent, dialogConfig);
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        if(data.guestMasterProfileId)
        {
          this.form1.patchValue({
            guestMasterProfileId: data.guestMasterProfileId,
            guestProfile: {
              guestMasterProfileId: data.guestMasterProfileId
            }
          });
        }
        if(data.firstName)
        {
          this.form1.patchValue({
            guestProfile: {
              firstName: data.firstName
            }
          });
        }
        if(data.lastName)
        {
          this.form1.patchValue({
            guestProfile: {
              lastName: data.lastName
            }
          });
        }
        if(data.emailAddress)
        {
          this.form1.patchValue({
            guestProfile: {
              emailAddress: data.emailAddress
            }
          });
        }
        if(data.mobilePhone)
        {
          this.form1.patchValue({
            guestProfile: {
              mobilePhone: data.mobilePhone
            }
          });
        }
        // close the dialogBox
        dialogRef.close();
      });

  }

  closePopUp(){
    // this.location1.go('/reservations');
    this.redirectToQuotes();
  }

  redirectToQuotes(){
    if(this.searchName != null && this.searchName != undefined && this.searchName != ""){
      // const data ={
      // 	searchName: this.searchName
      // }
      // const formData = JSON.parse(JSON.stringify(data));

      this.router.navigate(['/quote-list'], { queryParams: { searchName: this.searchName} });
      this.doUpdate.emit(this.searchName);
    }
  }

  closePopUpOfQuote(){
    this.doUpdate.emit(null);
  }

  ngOnDestroy(): void {
    // Remove the class from body on component destroy
    this.renderer.removeClass(document.body, 'custom-body-class');
    this.currentUserSubscription?.unsubscribe();
  }

  updateReQuotes() {

  }

  updateQuote() {

  }
}
